import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeCurrencyCommand extends BaseCommand {
  CommandName = "ChangeCurrency";
  Command: { Value: string };
  constructor(sessionId: string, operationId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
